import _ from 'lodash';
import React, { Fragment, FunctionComponent, useState } from 'react';
import {
	EpiAccount,
	FinancialPlanningSoftware,
} from '../../../../logic/domains/epi.domain';
import { Text } from '@mlc/web-ui-toolkit';
import Products from '../Products/Products';
import Username from '../Username/Username';
import Password from '../Password/Password';
import ViewEdit from '../Common/ViewEdit';
import ViewPasswordMask from '../Password/ViewPasswordMask';
import UpdatePassword from '../Password/UpdatePassword';
import ViewProductOptions from '../Products/ViewProductOptions';
import UpdateProductOptions from '../Products/UpdateProductOptions';

type Props = {
	token: string;
	account?: EpiAccount;
	fpsOptions: FinancialPlanningSoftware[];
};

const ViewAccount: FunctionComponent<Props> = ({
	token,
	account,
	fpsOptions,
}) => {
	const [epiAccount, setEpiAccount] = useState(account);
	const [isPasswordActive, setPasswordActive] = useState(false);
	const [isFpsActive, setFpsActive] = useState(false);

	if (!epiAccount) {
		throw new Error('Account data is missing');
	}

	return (
		<Fragment>
			<Username>
				<Text marginTop={1} aria-hidden={true} style={{ letterSpacing: '5px' }}>
					{epiAccount.id}
				</Text>
				<span className="sr-only">{_.split(epiAccount.id, '').join(' ')}</span>
			</Username>
			<Password mode={isPasswordActive ? 'edit' : 'view'}>
				<ViewEdit
					onModeChange={setPasswordActive}
					view={<ViewPasswordMask enableEdit={epiAccount.isActive} />}
					edit={<UpdatePassword token={token} />}
				/>
			</Password>
			<Products mode={isFpsActive ? 'edit' : 'view'}>
				<ViewEdit
					onModeChange={setFpsActive}
					view={
						<ViewProductOptions
							key={'viewProductsKey'}
							account={epiAccount}
							enableEdit={epiAccount.isActive}
						/>
					}
					edit={
						<UpdateProductOptions
							key={'editProductsKey'}
							token={token}
							fpsOptions={fpsOptions}
							account={epiAccount}
							onUpdate={(fps: FinancialPlanningSoftware[]) =>
								setEpiAccount({ ...epiAccount, fps: fps })
							}
						/>
					}
				/>
			</Products>
		</Fragment>
	);
};

export default ViewAccount;
